export default {
  title: 'Configurer les exécutions de forfait',
  form: {
    title: 'Créer une exécution',
    companies: {
      label: 'Entreprises',
    },
  },
  table: {
    title: 'Historique des exécutions',
    fields: {
      name: 'Entreprise',
      fulfilled: 'Exécuté le',
    },
  },
  buttons: {
    create_fulfillment: 'Créer une exécution',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_create_fulfillment: "Échec de la création de l'exécution",
  },
};
